<template>
  <div class="fill-height">
    <v-content class="fill-height">
      <v-container fluid>
        <v-card rounded>
          <PageBar :title="title" :back="true"/>
          <v-container fluid>
            <v-row>
              <v-col md="5" sm="12" cols="12">
                <v-menu
                    ref="menu"
                    v-model="period.from.menu"
                    :close-on-content-click="false"
                    :return-value.sync="period.from.date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        label="Дата начала периода"
                        outlined
                        hide-details
                        dense
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-model="period.from.date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="period.from.date"
                      no-title
                      scrollable
                      locale="ru"
                      color="primary"
                  >
                    <v-spacer/>
                    <v-btn
                        text
                        color="grey"
                        @click="period.from.menu = false"
                    >
                      Отменить
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(period.from.date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="5" sm="12" cols="12">
                <v-menu
                    ref="menu2"
                    v-model="period.to.menu"
                    :close-on-content-click="false"
                    :return-value.sync="period.to.date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        label="Дата конца периода"
                        outlined
                        hide-details
                        dense
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-model="period.to.date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="period.to.date"
                      no-title
                      scrollable
                      locale="ru"
                      color="primary"
                  >
                    <v-spacer/>
                    <v-btn
                        text
                        color="grey"
                        @click="period.to.menu = false"
                    >
                      Отменить
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.menu2.save(period.to.date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2" sm="12" cols="12">
                <v-btn color="primary" block :loading="loading.report" @click="getUnixTime">Отчёт</v-btn>
              </v-col>
            </v-row>
          </v-container>
          <template v-if="result">
            <v-divider/>
            <v-toolbar flat>
              <v-toolbar-title>Результаты запроса</v-toolbar-title>
              <v-spacer/>
              <v-menu
                  bottom
                  left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      color="white"
                      :disabled="!list"
                      :loading="loading.download"
                      v-bind="attrs"
                      v-on="on"
                  >
                    Скачать отчёт <v-icon right small>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="printReport('pdf')">
                    <v-list-item-icon class="mr-3">
                      <v-icon color="red">mdi-file-pdf-box</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        Скачать в PDF
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="printReport('xlsx')">
                    <v-list-item-icon class="mr-3">
                      <v-icon color="green">mdi-file-excel</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        Скачать в XLSX
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">№</th>
                  <th class="text-left">Номер запроса</th>
                  <th class="text-left">Краткое описание</th>
                  <th class="text-left" width="110px">Дата регистрации</th>
                  <th class="text-left">Приоритет</th>
                  <th class="text-left" width="110px">Дата план</th>
                  <th class="text-left" width="110px">Дата факт</th>
                  <th class="text-left">Статус</th>
                  <th class="text-left">Чел/часы</th>
                </tr>
                </thead>
                <tbody v-if="list">
                <tr v-for="(item, index) in list"
                    :key="'report_item_key_'+index"
                    :style="item.status === 2 ? 'background-color: rgb(76, 175, 80, 0.27)' : ''"
                >
                  <template v-if="item.type === 'ticket'">
                    <td v-text="index + 1"/>
                    <td v-text="item.id" />
                    <td v-html="item.title" />
                    <td v-text="item.created" />
                    <td v-text="item.priority"
                        :style="item.priority === 'Высокий' ? 'background-color: #d87c77; color: #ffffff' : ''"
                    />
                    <td>
                      <div v-for="(date, indexB) in item.planed"
                           :key="'report_planned_key_'+indexB"
                      >
                        <span :class="item.planed.length === 1 ? '' : indexB + 1 === item.planed.length ? '' : 'thunderbird--text text-decoration-line-through'" v-text="date.date"/><br/>
                      </div>
                    </td>
                    <td v-text="item.canceled === '' ? '—' : item.canceled"/>
                    <td v-text="item.status === 0 ? 'В работе' : item.status === 1 ? 'На проверке' : item.status === 2 ? 'Закрыт' : 'На уточнении'"/>
                    <td v-text="item.hours" />
                  </template>
                  <template v-else-if="item.type === 'deposit'">
                    <td v-text="index + 1"/>
                    <td colspan="2">Зачисление предоплаченных часов</td>
                    <td colspan="5">{{ item.created }}</td>
                    <td class="font-weight-bold">
                      {{ item.hours }}
                    </td>
                  </template>
                </tr>
                <tr>
                  <td colspan="9" class="text-right font-weight-bold">
                    Итого часов начислено: {{ totalDeposits }}<br/>
                    Итого часов использовано: {{ totalExp }}<br/>
                    Итого часов доступно: {{ balance }}
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="8">За указанный период выписки отсутствуют.</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-card>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: 'AccountPassword',
  components: {
    PageBar: ()  => import('@/components/bar/Page.vue'),
  },
  data: () => ({
    title: "Детализация",
    list: [],
    result: false,
    loading: {
      report: false,
      download: false,
    },
    period: {
      from: {
        date: new Date().toISOString().substr(0, 10),
        //date: "2021-08-01",
        menu: false
      },
      to: {
        date: new Date().toISOString().substr(0, 10),
        menu: false
      }
    },
    unix: {
      from: 0,
      to: 0
    },
    totalHours: 0,
    balance: 0
  }),
  computed: {
    totalDeposits() {
      let total = 0;
      for(let i = 0; i < this.list.length; i++) {
        let item = this.list[i];
        if (item.type === "deposit") {
          total = total + item.hours;
        }
      }
      return total;
    },
    totalExp() {
      let total = 0;
      for(let i = 0; i < this.list.length; i++) {
        let item = this.list[i];
        if (item.type === "ticket") {
          total = total + item.hours;
        }
      }
      return total;
    }
  },
  methods: {
    getUnixTime() {
      this.loading.report = true;
      let params = new FormData();
      params.append('from', this.period.from.date );
      params.append('to', this.period.to.date );
      this.$http.post(`${this.$crmApiLink}api/tools/unix_converter`, params).then(
          response => {
            if (response.data.event) {
              this.unix = response.data.unix;
              this.getScreenData();
            } else {
              this.$store.commit('setSnack', {
                status: true,
                code: 400,
                message: 'Не удалось получить время UNIX',
                type: 'error'
              });
            }
          }
      ).catch(
          error => {
            console.log(error);
            this.$store.commit('setSnack', {
              status: true,
              code: 400,
              message: 'Не удалось получить время UNIX',
              type: 'error'
            });
            this.loading.report = false;
          }
      );
    },
    printReport(type) {
      this.loading.download = true;
      this.$http.post(`${this.$serverApiLink}account/report_print/${type}`, {
        'from': this.unix.from,
        'to': this.unix.to,
      }).then(
          response => {
            window.location.href = response.data.data.src;
            this.loading.download = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            this.loading.download = false;
          }
      );
    },
    getScreenData() {
      this.loading.report = true;
      this.$http.post(`${this.$serverApiLink}account/report`, {
        'from': this.unix.from,
        'to': this.unix.to,
      }).then(
          response => {
            this.list = response.data.data.items;
            this.balance = response.data.data.balance;
            for (let i = 0; i < response.data.data.length; i++) { // выведет 0, затем 1, затем 2
              this.totalHours = this.totalHours + response.data.data[i].hours;
            }
            this.result = true;
            this.loading.report = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            this.loading.report = false;
          }
      );
    }
  }
}
</script>